import React, { useState, useRef, useEffect } from "react";
import "./RegionDropdown.css";

const RegionDropdown = ({ regions, value, onChange, getRegionIcon }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState("");
  const dropdownRef = useRef(null);

  const selectedRegion = regions.find((r) => r.slug === value);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  // Filter and sort regions
  const filteredRegions = regions
    .filter((region) => {
      const searchLower = search.toLowerCase();
      return (
        region.name.toLowerCase().includes(searchLower) ||
        region.slug.toLowerCase().includes(searchLower)
      );
    })
    .sort((a, b) => a.name.localeCompare(b.name));

  const handleSelect = (region) => {
    onChange(region.slug);
    setIsOpen(false);
    setSearch("");
  };

  return (
    <div className="modern-dropdown" ref={dropdownRef}>
      <div
        className={`dropdown-trigger ${isOpen ? "open" : ""}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className="dropdown-trigger-content">
          {selectedRegion ? (
            <>
              <div className="dropdown-flag">
                {getRegionIcon(selectedRegion.slug)}
              </div>
              <div className="dropdown-text">
                <div className="dropdown-label">{selectedRegion.name}</div>
                <div className="dropdown-sublabel">{selectedRegion.slug}</div>
              </div>
            </>
          ) : (
            <div className="dropdown-text">
              <div className="dropdown-label">Select a region</div>
            </div>
          )}
        </div>
        <svg
          className={`dropdown-arrow ${isOpen ? "rotated" : ""}`}
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M5 7.5L10 12.5L15 7.5"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>

      {isOpen && (
        <div className="dropdown-menu">
          <div className="dropdown-search">
            <svg
              className="region-search-icon"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                d="M7 12C9.76142 12 12 9.76142 12 7C12 4.23858 9.76142 2 7 2C4.23858 2 2 4.23858 2 7C2 9.76142 4.23858 12 7 12Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M14 14L10.5 10.5"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <input
              type="text"
              placeholder="Search regions..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              onClick={(e) => e.stopPropagation()}
              autoFocus
            />
          </div>

          <div className="dropdown-options">
            {filteredRegions.length > 0 ? (
              filteredRegions.map((region) => (
                <div
                  key={region.slug}
                  className={`dropdown-option ${
                    value === region.slug ? "selected" : ""
                  }`}
                  onClick={() => handleSelect(region)}
                >
                  <div className="dropdown-flag">
                    {getRegionIcon(region.slug)}
                  </div>
                  <div className="dropdown-option-text">
                    <div className="dropdown-option-name">{region.name}</div>
                    <div className="dropdown-option-slug">{region.slug}</div>
                  </div>
                  {value === region.slug && (
                    <svg
                      className="check-icon"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        d="M13.3337 4L6.00033 11.3333L2.66699 8"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  )}
                </div>
              ))
            ) : (
              <div className="dropdown-empty">No regions found</div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default RegionDropdown;
